"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvgMetricsReviewRatings = exports.IndividualReviewRatings = exports.RatingStarValue = exports.RatingTitle = exports.SubRatingRow = exports.SubRatingsContainer = exports.AverageRatingHeading = exports.StyledStar = exports.StyledStarOutline = exports.FilledStars = exports.EmptyStars = exports.StarWrapper = exports.SummaryStars = exports.AverageRatingContainer = exports.RatingsSection = exports.CancelButton = exports.SearchIconWrapper = exports.SearchInputContainer = exports.ReviewsSearchInputTitle = exports.ReviewsDisclaimer = exports.RatingsReviewsCount = exports.ReviewsTitle = exports.ReviewsHeader = void 0;
const styled_1 = __importDefault(require("@emotion/styled"));
const ui_theme_1 = require("@kyruus/ui-theme");
const Star_1 = __importDefault(require("@kyruus/react-ikons/Star"));
const StarOutline_1 = __importDefault(require("@kyruus/react-ikons/StarOutline"));
const constants_1 = require("../../lib/constants");
const { STAR_INNER_MARGIN } = constants_1.RATINGS_AND_REVIEWS;
exports.ReviewsHeader = styled_1.default.header `
  display: flex;
  justify-content: space-between;
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.ReviewsTitle = styled_1.default.h2 `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size_heading_4')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  margin: 0;
`;
exports.RatingsReviewsCount = styled_1.default.span `
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  align-self: center;
`;
exports.ReviewsDisclaimer = styled_1.default.p `
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0;
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
`;
exports.ReviewsSearchInputTitle = styled_1.default.strong `
  display: block;
  color: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  line-height: ${(0, ui_theme_1.fromTheme)('font_line_height')};
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_large')};
  margin-bottom: ${(0, ui_theme_1.fromTheme)('spacing_xsmall')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
`;
exports.SearchInputContainer = styled_1.default.div `
  position: relative;
  max-width: 290px;

  label {
    padding: 0;
  }

  input {
    padding-left: ${(0, ui_theme_1.fromTheme)('spacing_small')};
    padding-right: ${(0, ui_theme_1.fromTheme)('spacing_large')};
    border-radius: ${(props) => (0, ui_theme_1.fromTheme)('provider_profile_border_radius')(props)};

    // prevent borders from being cut off because outlines are drawn outside of the elements border
    // and outline is not a part of an element's dimensions
    margin-left: ${(0, ui_theme_1.fromTheme)('border_width')};
  }

  @media print {
    display: none;
  }
`;
exports.SearchIconWrapper = styled_1.default.div `
  position: absolute;
  pointer-events: none;
  top: 50%;
  transform: translateY(-50%);
  right: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  color: ${(0, ui_theme_1.fromTheme)('color_info')};

  svg path {
    fill: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  }
`;
exports.CancelButton = (0, styled_1.default)('button') `
  position: absolute;
  padding: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  appearance: none;
  border: 0;
  margin: 0;
  background: transparent;
  top: 2px;
  right: 0;
  cursor: pointer;
  outline: 0;

  svg path {
    fill: ${(0, ui_theme_1.fromTheme)('color_text_secondary')};
  }

  &:focus {
    outline-color: ${(0, ui_theme_1.fromTheme)('color_link')};
    outline-width: ${(0, ui_theme_1.fromTheme)('border_width')};
    outline-style: solid;
    outline-offset: 0px;
    border-radius: ${(0, ui_theme_1.fromTheme)('provider_profile_border_radius')};
  }
`;
// ------------------------------------------
// Ratings Section
// ------------------------------------------
exports.RatingsSection = styled_1.default.div ``;
// Average Rating
exports.AverageRatingContainer = styled_1.default.div `
  display: flex;
  margin-top: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
  gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  line-height: ${(0, ui_theme_1.fromTheme)('spacing_medium')};
`;
exports.SummaryStars = styled_1.default.div `
  // starSize by ratingScale (number of max stars)
  // add margin for all stars except last one
  // add correction factor to make the star rating display accurately
  width: calc(
    ${(props) => {
    const { starSize, ratingScale, widthAccuracyCorrection } = props;
    return `${starSize}px * ${ratingScale} +
      ${STAR_INNER_MARGIN}px * (${ratingScale} - 1) -
      ${widthAccuracyCorrection}px`;
}}
  );
  @media screen and (max-width: ${constants_1.BREAKPOINTS.small}px) {
    display: none;
  }
`;
exports.StarWrapper = styled_1.default.div `
  position: relative;
  width: 100%;
  svg {
    color: ${(0, ui_theme_1.fromTheme)('color_star_ratings')};
  }
`;
exports.EmptyStars = styled_1.default.div `
  position: absolute;
  width: 100%;
  white-space: nowrap;
  overflow: hidden;
`;
exports.FilledStars = styled_1.default.div `
  position: absolute;
  width: ${(props) => props.filledPercent};
  white-space: nowrap;
  overflow: hidden;
`;
exports.StyledStarOutline = (0, styled_1.default)(StarOutline_1.default) `
  :not(:last-child) {
    margin-right: ${STAR_INNER_MARGIN}px;
  }
`;
exports.StyledStar = (0, styled_1.default)(Star_1.default) `
  :not(:last-child) {
    margin-right: ${STAR_INNER_MARGIN}px;
  }
`;
exports.AverageRatingHeading = styled_1.default.h3 `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bolder')};
  margin: 0;
`;
// Sub Ratings
exports.SubRatingsContainer = styled_1.default.div `
  display: flex;
  flex-direction: column;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  margin: ${(0, ui_theme_1.fromTheme)('spacing_medium')} 0 0;
`;
exports.SubRatingRow = styled_1.default.div `
  display: flex;
  justify-content: space-between;
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  align-items: center;
`;
exports.RatingTitle = styled_1.default.span `
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight_bold')};
`;
exports.RatingStarValue = styled_1.default.div `
  display: flex;
  gap: ${(0, ui_theme_1.fromTheme)('spacing_small')};
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  border-radius: ${(0, ui_theme_1.fromTheme)('border_radius_rounded')};
  padding: 2px 2px 2px 12px;
`;
exports.IndividualReviewRatings = styled_1.default.div `
  color: ${(0, ui_theme_1.fromTheme)('color_text')};
  font-size: ${(0, ui_theme_1.fromTheme)('font_size')};
  font-weight: ${(0, ui_theme_1.fromTheme)('font_weight')};
  flex-grow: 1;
  margin: 0;
  padding-left: ${(0, ui_theme_1.fromTheme)('spacing_small')};

  .sr-only {
    position: absolute;
    width: 1px;
    height: 1px;
    padding: 0;
    margin: -1px;
    overflow: hidden;
    clip: rect(0, 0, 0, 0);
    border: 0;
  }
`;
exports.AvgMetricsReviewRatings = (0, styled_1.default)(exports.IndividualReviewRatings) `
  padding-left: 0;
`;
//# sourceMappingURL=styles.js.map